import { render } from "./Deportes.vue?vue&type=template&id=fe5c741c"
import script from "./Deportes.vue?vue&type=script&lang=js"
export * from "./Deportes.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__